var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuInputActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#0D5CDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1362 22.2166L34.6899 21.6629C35.6072 20.7455 37.0947 20.7455 38.012 21.6629C38.9294 22.5803 38.9294 24.0676 38.012 24.985L37.4584 25.5387M34.1362 22.2166C34.1362 22.2166 34.2055 23.3932 35.2436 24.4313C36.2818 25.4694 37.4584 25.5387 37.4584 25.5387M34.1362 22.2166L29.0459 27.3068C28.7011 27.6516 28.5287 27.824 28.3804 28.0141C28.2056 28.2384 28.0557 28.481 27.9333 28.7376C27.8296 28.9553 27.7525 29.1865 27.5983 29.6491L27.1047 31.1301L26.9449 31.6092M37.4584 25.5387L32.3681 30.629C32.0233 30.9738 31.8509 31.1462 31.6608 31.2945C31.4365 31.4693 31.1939 31.6192 30.9373 31.7416C30.7196 31.8453 30.4884 31.9224 30.0258 32.0766L28.5448 32.5702L28.0657 32.73M26.9449 31.6092L26.7852 32.0884C26.7093 32.316 26.7686 32.567 26.9382 32.7367C27.1079 32.9063 27.3589 32.9656 27.5865 32.8897L28.0657 32.73M26.9449 31.6092L28.0657 32.73",
    stroke: "white",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9749 28.1416H24.9617",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9749 23.3638H29.7406",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9749 32.9221H23.767",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3368V24.5579C16 20.0522 16 17.7994 17.3997 16.3997C18.7994 15 21.0522 15 25.5579 15H27.9473C32.4529 15 34.7058 15 36.1055 16.3997M37.5052 29.3368C37.5052 33.8424 37.5052 36.0953 36.1055 37.4949M36.1055 37.4949C34.7058 38.8947 32.4529 38.8947 27.9473 38.8947H25.5579C21.0522 38.8947 18.7994 38.8947 17.3997 37.4949M36.1055 37.4949C37.2322 36.3682 37.4519 34.6888 37.4948 31.7263",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInputActive);
export default __webpack_public_path__ + "static/media/menu_input_active.fb661fdd797d171d43aa809aaaf17e46.svg";
export { ForwardRef as ReactComponent };